define("shared/utils/compare-strings", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.areStringsEqual = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * @module Utils
   */

  /**
   * @class compareStrings
   * @extends Utils
   */

  /**
   * Compares two normalized strings
   *
   * @method areStringsEqual
   * @param {Any} str1 A value to compare as a string to another
   * @param {Any} str2 Second value to compare as a string to another
   *
   * @return {Boolean} Whether or not the strings are equal
   */

  const areStringsEqual = function () {
    let str1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let str2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return `${str1}`.toLowerCase() === `${str2}`.toLowerCase();
  };
  _exports.areStringsEqual = areStringsEqual;
});